export default "__VITE_ASSET__7Fn6A16H__"